export function normalizeFormationName(name) {
  if (!name) return '';
  return name
    .normalize('NFD')                          // décompose les accents
    .replace(/[\u0300-\u036f]/g, '')           // supprime les diacritiques
    .toLowerCase()
    .replace(/\s+/g, '-')                      // espaces → tirets
    .replace(/[^a-z0-9-]/g, '')                // ne garde que alphanum + tiret
    .replace(/-+/g, '-')                       // plusieurs tirets → un seul
    .replace(/^-+|-+$/g, '');                  // enlève tirets début/fin
}